import { useEffect, useState, useTransition } from 'react';
import { useCountUp } from 'react-countup';

import calcResumeProgress from '@glass/common/modules/resumes/calcResumeScore/calcResumeProgress';
import useParseInt from '@glass/common/modules/utils/useParseInt';

import { useResumeBuilderSteps } from '@glass/shared/components/ResumeBuilder/BuilderContext/ResumeBuilderStepProvider';
import { useTrackingPath } from '@glass/shared/modules/tracking/useTrackingProp';

const useCount = ({ value = 0 }) => {
  const { countUp, update } = useCountUp({
    start: value,
    end: value,
    preserveValue: true,
    duration: 6,
  });
  useEffect(() => {
    update(value);
  }, [update, value]);
  const count = useParseInt(countUp);
  return { count };
};

const useResumeProgress = (resume) => {
  const [progress, setProgress] = useState(() => calcResumeProgress(resume));
  const [isPending, startTransition] = useTransition();
  const { isBuilderPage } = useResumeBuilderSteps();
  useTrackingPath('resumeProgress', isBuilderPage && progress > 0 ? progress : null);
  useEffect(() => {
    startTransition(() => {
      // defer this potentially expensive calculation
      setProgress(calcResumeProgress(resume));
    });
  }, [resume]);

  const { count } = useCount({ value: progress });
  return { count, progress, isPending };
};

export default useResumeProgress;
